import { Button } from "react-bootstrap";

function CustomButton({ link, value }) {
    return (
        <Button href={ link } className="mx-auto px-4 py-2" style={{ width: "210px" }}>{ value }</Button>
    )
};

export default CustomButton;
